
import lozad from 'lozad';

let observer;

export const init = () => {
  const PRODUCT_PRINTED = 'product-printed';

  CUBE.Analytics = CUBE.Analytics || {};
  CUBE.Analytics.enhanced.sparepart = Object.assign({}, CUBE.Analytics.enhanced.sparepart, {
    es6: {
      getProduct: element => {
        // Be sure to have a vanilla js element
        if (element.length) element = element[0];
        return element.closest('.pl-element');
      },
      getModelId: element => {
        const div = element.querySelector('[data-model-reference]');
        return (div && div.dataset.modelReference) ? div.dataset.modelReference : '';
      },
      getName: element => element.querySelector('.title .name').textContent.trim(),
      getPrice: element => parseInt(element.querySelector('[data-price]').dataset.price.trim(), 10),
      getBrand: element => {
        const result = element.querySelector('.title .brand').textContent.trim();
        return (result) ? CUBE.Analytics.enhanced.sparepart.es6.getRealBrandName(result) : '';
      },
      getPosition: element => Array.from(document.querySelectorAll('.pl-element:not(.contact)')).indexOf(element) + 1,
      getVada: element => {
        const elt = element.querySelector('.inner-element');
        const dataset = elt ? elt.dataset : {};
        return {
          family: dataset.family || '',
          department: dataset.department || '',
          subdepartment: dataset.subdepartment || '',
          universe: dataset.universe || ''
        };
      },
      getRealBrandName: brand => {
        let result = brand;
        if (/^[a-z]{1}_(.*)/.test(brand)) {
          result = brand.substr(2);
        }
        return result.toUpperCase();
      },

      setProductAsPrinted: element => element.classList.add(PRODUCT_PRINTED),

      productIsPrinted: element => element.classList.contains(PRODUCT_PRINTED),

      /**
       * Builds a MODEL object
       */
      getSelectedModel: (element) => {
        element = CUBE.Analytics.enhanced.sparepart.es6.getProduct(element);
        const vada = CUBE.Analytics.enhanced.sparepart.es6.getVada(element);

        return {
          type: 'product',
          id: CUBE.Analytics.enhanced.sparepart.es6.getModelId(element),
          name: CUBE.Analytics.enhanced.sparepart.es6.getName(element),
          brand: CUBE.Analytics.enhanced.sparepart.es6.getBrand(element),
          position: CUBE.Analytics.enhanced.sparepart.es6.getPosition(element),
          list: `spareparts:${CUBE.Analytics.utils.getInfoNavFromURLForEnhancedEcommerce(document.location.pathname + document.location.search)}`,
          price: CUBE.Analytics.enhanced.sparepart.es6.getPrice(element),
          variant: element.querySelector('.inner-element').dataset.nature.trim(),
          category: `${vada.universe}/${vada.department}/${vada.subdepartment}/${vada.family}`,
          sticker: '',
          vada
        };
      },

      /**
       * Executed when a product is visible in viewport
       */
      sendImpression: (element) => {
        const model = CUBE.Analytics.enhanced.sparepart.es6.getSelectedModel(element);
        element = CUBE.Analytics.enhanced.sparepart.es6.getProduct(element);

        if (!CUBE.Analytics.enhanced.sparepart.es6.productIsPrinted(element)) {
          CUBE.Analytics.enhanced.sparepart.es6.setProductAsPrinted(element);
          CUBE.Analytics.enhanced.sendImpression(model);
        }
      },

      initImpression: () => {
        observer = lozad(`.pl-element:not(.contact)`, {
          threshold: 0.5,
          loaded: element => {
            if (!element) return;
            CUBE.Analytics.enhanced.sparepart.es6.sendImpression(element);
          }

        });

        CUBE.Analytics.enhanced.sparepart.es6.updateObserver();
      },

      /**
       * Function to update the lazyObserver after a DOM change / insertion
       *
       */
      updateObserver: () => {
        if (observer && observer.observe) {
          observer.observe();
        } else {
          console.warn('Lazyload : lazyObserver was not correctly initialized !');
        }
      }

    }
  });
};



// WEBPACK FOOTER //
// ./src/analytics/framework/utils/sparepart.js